var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex align-items-center justify-content-between w-100" },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("font-awesome-icon", {
            staticClass: "color-purple mr-2",
            attrs: { icon: ["far", "map"] },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_setup.itemLabel))]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(_setup.CButton, {
            directives: [{ name: "tippy", rawName: "v-tippy" }],
            attrs: {
              content: "Set as Default Style",
              size: "icon",
              icon: [_vm.isDefault ? "fas" : "far", "star"],
              disabled: _vm.readonly,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("set-default", _vm.id)
              },
            },
          }),
          _vm._v(" "),
          _setup.isEditable
            ? _c(_setup.CButton, {
                attrs: {
                  size: "icon",
                  icon: ["far", "pen"],
                  disabled: _vm.readonly,
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("edit", _vm.id)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.CButton, {
            attrs: {
              size: "icon",
              icon: ["far", "trash-can"],
              disabled: _vm.readonly,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("remove", _vm.item)
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }